import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { IMaestroDocumentoCreateModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoCreateModel';
import { MaestroDocumentoCreateModel } from 'src/app/models/maestro-documento/MaestroDocumentoCreateModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaestroDocumentosService } from 'src/app/services/maestro-documentos/maestro-documentos.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-maestro-documento-registrar',
  templateUrl: './maestro-documento-registrar.component.html',
  styleUrls: ['./maestro-documento-registrar.component.css']
})
export class MaestroDocumentoRegistrarComponent implements OnInit {
  model: IMaestroDocumentoCreateModel = new MaestroDocumentoCreateModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private router: Router,
    private maestroDocumentoService: MaestroDocumentosService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
  ) { }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_DOCUMENTO).subscribe((data) => {
      this.listaEstados = data.items;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {  
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.maestroDocumentoService.submit(this.model).subscribe((data) => {
            this.router.navigate(['/configuracion', 'maestro-documentos']);  
          });
        }
      });
    }
  }
}
